import { Formik } from 'formik'
import React from 'react'
import * as yup from 'yup'
import Link from 'next/link'
import {
  Button,
  FormCheckbox,
  FormField,
  FormInput,
  FormLayout,
  FormInputPassword,
} from '@next-nx/shared-ui/atoms'

const validationSchema = yup.object().shape({
  email: yup.string().email("Il formato dell'email dev'essere valido").required().nullable(),
  password: yup.string().required().nullable(),
  ricordati: yup.boolean().nullable(),
})

const FormLogin = () => (
  <Formik
    isInitialValid={false}
    validateOnChange
    onSubmit={(values) => console.log('Accedi', values)}
    initialValues={{ email: null, password: null, ricordati: null }}
    validationSchema={validationSchema}
  >
    {(props) => (
      <FormLayout>
        <FormField
          label="Email"
          status={props.touched.email ? (props.errors.email ? 'error' : 'success') : null}
          errorMessage={props?.errors?.email as string}
        >
          <FormInput
            onBlur={props.handleBlur('email')}
            placeholder="Email"
            value={props.values.email}
            onChange={props.handleChange('email')}
          />
        </FormField>
        <FormField
          label="Password"
          status={props.touched.password ? (props.errors.password ? 'error' : 'success') : null}
          errorMessage={props?.errors?.password as string}
        >
          <FormInputPassword
            togglePassword={false}
            placeholder="Password"
            onBlur={props.handleBlur('password')}
            value={props.values.password}
            onChange={props.handleChange('password')}
          />
        </FormField>
        <FormField>
          <FormCheckbox
            label="Ricordati di me"
            id="ricordati"
            checked={props.values.ricordati}
            onChange={(e) => props.setFieldValue('ricordati', e.target.checked)}
          />
        </FormField>
        <Link href="#">Hai dimenticato la password ?</Link>
        <Button
          label="Accedi"
          onClick={() => props.handleSubmit()}
          disabled={Object.values(props.errors).length > 0}
        />
      </FormLayout>
    )}
  </Formik>
)

export default FormLogin
